import { get } from "lodash-es";
import { BasicTeamT } from "../../Overview/TeamStats/TeamStatsHeader";
import type { Maybe, GetEfficiencyStatsQuery } from "@/graphql/gql/graphql";

export const teamDataToSuccessRateStats = (team?: Maybe<BasicTeamT>) => {
  const stats = get(team, "teamStats.efficiencyStats", {});

  return {
    team: {
      abbreviation: get(team, "abbreviation", ""),
      logoSVG: get(team, "logoSVG", ""),
    },
    offense_value: get(stats, "adjOffNEP", 0),
    passing_value: get(stats, "adjOffPassNEP", 0),
    rushing_value: get(stats, "adjOffRushNEP", 0),
    defense_value: get(stats, "adjDefNEP", 0),
    pass_defense_value: get(stats, "adjDefPassNEP", 0),
    rush_defense_value: get(stats, "adjDefRushNEP", 0),
  };
};

export const createTableData = (data?: GetEfficiencyStatsQuery["event"]) => {
  const homeTeam = data?.homeTeam;
  const awayTeam = data?.awayTeam;
  const homeStats = teamDataToSuccessRateStats(homeTeam);
  const awayStats = teamDataToSuccessRateStats(awayTeam);

  return [homeStats, awayStats];
};
